import { HaftarahType, ParashahType } from 'types/types'

export const HAFTARAH_VARIANT_ASHKENAZI = 'A'
export const HAFTARAH_VARIANT_SEPHARDIC = 'S'

/** A custom haftarah to save; `id` (its reading id) is null for a new one. */
export interface CreateHaftarahParameters {
  comment: string | null
  id: number | null
  parashah: ParashahType
  section: string
  username: string
  variant: string
  year: number | null
}

export function formatHaftarahForTeacher(haftarah: HaftarahType): string {
  let h = `${haftarah.parashah.heTitle} / ${haftarah.parashah.transliteratedTitle}`
  if (haftarah.year != null) {
    h += ` @ ${haftarah.year}`
  }
  if (haftarah.variant === HAFTARAH_VARIANT_ASHKENAZI) {
    h += ' (Ashkenazi)'
  } else if (haftarah.variant === HAFTARAH_VARIANT_SEPHARDIC) {
    h += ' (Sephardic)'
  }

  if (haftarah.comment) {
    h += ` / ${haftarah.comment}`
  }

  h += `: ${haftarah.section}`

  return h
}

export function formatHaftarahForStudent(haftarah: HaftarahType): string {
  return `${haftarah.parashah.transliteratedTitle} / [${haftarah.parashah.heTitle}]`
}

export function formatHaftarahSimple(haftarah: HaftarahType): string {
  const base = formatHaftarahForStudent(haftarah)
  return haftarah.year != null ? `${base} @ ${haftarah.year}` : base
}
